import React from 'react';
import { History, Check, X } from 'lucide-react';
import type { Exercise } from '../types';

interface ExerciseHistoryProps {
  exercises?: Exercise[];
}

export function ExerciseHistory({ exercises = [] }: ExerciseHistoryProps) {
  const getOperationSymbol = (operation: string) => {
    switch (operation) {
      case 'add': return '+';
      case 'subtract': return '-';
      case 'multiply': return '×';
      case 'divide': return '÷';
      default: return '';
    }
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow-md">
      <h2 className="text-xl font-bold mb-4 flex items-center">
        <History className="w-6 h-6 mr-2" />
        Historia zadań
      </h2>
      <div className="max-h-[300px] overflow-y-auto">
        {exercises.length === 0 ? (
          <p className="text-gray-500 text-center">Brak historii zadań</p>
        ) : (
          <div className="space-y-2">
            {exercises.slice().reverse().map((exercise) => (
              <div
                key={exercise.id}
                className={`p-3 rounded-lg ${
                  exercise.isCorrect ? 'bg-green-50' : 'bg-red-50'
                }`}
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <span className="text-lg">
                      {exercise.num1} {getOperationSymbol(exercise.operation)} {exercise.num2} = {exercise.userAnswer}
                    </span>
                    {exercise.isCorrect ? (
                      <Check className="w-5 h-5 text-green-500" />
                    ) : (
                      <div className="flex items-center">
                        <X className="w-5 h-5 text-red-500 mr-2" />
                        <span className="text-sm text-gray-600">
                          Poprawna odpowiedź: {exercise.correctAnswer}
                        </span>
                      </div>
                    )}
                  </div>
                  <span className="text-sm text-gray-500">
                    {new Date(exercise.timestamp).toLocaleTimeString()}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}